// Единицы измерения, которые используются для целых чисел
export const integerUnits = new Set(['голов', 'шт.']);

// Общие ограничения по длине
export const MIN_LENGTH = 0;
export const MAX_LENGTH = 255;

export const MAX_LENGTH_ADDRESS = 500;

// Ограничение для имени СПоК
export const MAX_LENGTH_SPOK_NAME = 200;

// Ограничение для площади
export const MAX_AREA = 500000000;

// Ограничения для количества/денег/площади
export const MIN_VALUE_TWO_DECS = 0.01;
export const MIN_VALUE_THREE_DECS = 0.001;
export const MAX_COUNT_LENGTH = 14;
